<template>
  <footer class="footer-area-wrapper footer-background">
    <div id="footer-area" class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper">

          <!-- Columna 1 -->
          <div class="col-lg-4 col-md-6 footer-widget">
            <div class="footer-widget__logo mb-30">
              <a href="#home" @click.prevent="smoothScroll('#home')">
                <img src="../assets/img/logo/img-logo-Footer.png" class="img-fluid" alt="Leonix" />
              </a>
            </div>

            <ul class="footer-widget__list">
              <li>
                <a class="hover-style-link" href="mailto:adrian.coria@leonix.com.mx">
                  adrian.coria@leonix.com.mx
                </a>
              </li>

              <li>
                <a class="hover-style-link" href="tel:+524431371292">
                  +52 (443) 137 1292
                </a>
              </li>
            </ul>
          </div>

          <!-- Columna 2 → Menú con scroll -->
          <div class="col-lg-4 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20 footer-title">Menú</h6>

            <ul class="footer-widget__list">
              <li><a href="#home" class="hover-style-link" @click.prevent="smoothScroll('#home')">Inicio</a></li>
              <li><a href="#about" class="hover-style-link" @click.prevent="smoothScroll('#about')">¿Quiénes somos?</a>
              </li>
              <li><a href="#service" class="hover-style-link" @click.prevent="smoothScroll('#service')">Qué hacemos</a>
              </li>
              <li><a href="#metodologia" class="hover-style-link"
                  @click.prevent="smoothScroll('#metodologia')">Metodología</a></li>
              <li><a href="#contact" class="hover-style-link" @click.prevent="smoothScroll('#contact')">Contacto</a>
              </li>
            </ul>
          </div>

          <!-- Columna 3 -->
          <div class="col-lg-4 col-md-12 footer-widget text-center frase-col">
            <h6 class="footer-frase">
              “Transformamos tus ideas en tecnología real.”
            </h6>
            <p class="footer-frase-sub">
              Somos tu equipo de desarrollo, innovación y diseño.
            </p>
          </div>

        </div>
      </div>
    </div>

    <div id="footer-extension" class="footer-copyright-area">
      <div class="container">
        <div class="row align-items-center">

          <div class="col-md-6 text-center text-md-left">
            <span class="copyright-text">
              © {{ new Date().getFullYear() }} <b>Leonix</b>. Todos los derechos reservados.
            </span>
          </div>

          <div class="col-md-6 text-center text-md-right">
            <a href="https://www.facebook.com/leonixti/" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-facebook-f"></i>
            </a>
          </div>

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterMain",

  methods: {
    smoothScroll(target) {
      const el = document.querySelector(target);
      if (!el) return;

      const OFFSET = 80;

      const top = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
  },
};
</script>


<style lang="sass">
@import "/src/assets/scss/_variabls"

.footer-background
  background-color: $clr-primary-400
  background-image: url("../assets/img/patterns/img-pattern-footer.png")
  background-size: cover
  background-repeat: no-repeat

.footer-widget__list li
  margin-bottom: 10px

.hover-style-link
  color: $clr-neutral-100
  transition: color .3s

.hover-style-link:hover
  color: $clr-neutral-300 !important

.footer-title
  color: $clr-neutral-100
  font-weight: 700

.frase-col
  margin-top: 25px

.footer-frase
  color: white
  font-size: 20px
  font-weight: 700
  line-height: 1.4
  max-width: 320px
  margin: 0 auto

.footer-frase-sub
  color: #e6e6e6
  margin-top: 10px
  font-size: 15px

#footer-extension
  padding: 15px 0
  border-top: 1px solid rgba(255,255,255,0.15)

.social-link
  color: white
  font-size: 20px
  padding: 10px
  border-radius: 50%
  border: 1px solid white
  transition: all .3s ease

.social-link:hover
  background: white
  color: $clr-primary-400

.footer-widget__list a,
.footer-widget__list a:visited,
.footer-widget__list a:active
  color: $clr-neutral-100 !important

.footer-widget__list a:hover
  color: $clr-neutral-300 !important

</style>
